import React, {useEffect, useState} from "react";
import "./chat-feedback-new.less";
import {useDispatch} from "react-redux";
import {ChatFeedbackProps} from "../../types/chat-feedback-types";
import {submitFeedbackAction} from "../../actions/chat-common-actions";
import {CONFIG} from "../../common/config";
import {isJson} from "../../utils/jsonVerification";
import {ok} from "assert";

const NewChatFeedback: React.FC<ChatFeedbackProps> = (props: ChatFeedbackProps) => {
    const [param, setParam] = useState<any>({});
    const [disable, setDisable] = useState(false);
    const [mandatoryList, setMandatoryList] = useState<string[]>([""]);
    const [currentStar, setCurrentStar] = useState<any>({});
    const [selectItems,setSelectItems] =useState<string[]>([""]);
    const [selectedIndex,setSelectIndex]=useState<number>(0);
    const [dependItems,setDependItems]= useState<boolean[]>([]);
    const [inputItem,setInputItem] = useState<string>(null);
    const [mandatoryItems,setMandatoryItems] = useState<number[]>([]);
    const isHistoryMsg = props.isHistoryMsg;
    const dispatch = useDispatch();
    const params = (props.param && isJson(props.param) && JSON.parse(props.param).items) ? JSON.parse(props.param) : JSON.parse(CONFIG.FEEDBACK_DEFAULT_PARAM);
    const surveyId = (props.param && isJson(props.param) && JSON.parse(props.param).surveyId) ? JSON.parse(props.param).surveyId : params.surveyId;
    let items = params.items;



    useEffect(() => {

        if (items) {
            items.sort(function (a, b) {
                a = a ? a : -1;
                b = b ? b : -1;
                return a.order - b.order;
            });
        }
        mandatoryList.splice(0, 1);
        items.map(item => {
            if (item.mandatory) {
                mandatoryList.push(item.field);
                mandatoryItems.push(item.order);
            }
        });
        setMandatoryItems(mandatoryItems);
        setMandatoryList(mandatoryList);
        let initialDependItems:boolean[]=[];
        for(let i=0;i<=items.length;i++){
              initialDependItems.push(false)
        }
        setDependItems(initialDependItems)

    }, []);

    const changeParam = (data: any) => {
        if (data) {
            let number = mandatoryList.indexOf(Object.keys(data)[0]);
            if (number >= 0) {
                mandatoryList.splice(number, 1);
                setMandatoryList(mandatoryList);
            }
            if (data[Object.keys(data)[0]] === '') {
                mandatoryList.push(Object.keys(data)[0]);
                setMandatoryList(mandatoryList);
            }
        }
        setParam({...param, ...data});
    }


    const checkAllMandatory = (exactDependItems:boolean[]) => {
        console.log("console:start");
        let flag=true;
        if(mandatoryItems&&mandatoryItems.length>0){
            mandatoryItems.forEach(item=>{
             if(!exactDependItems[item]){
                 flag = false;
             }
            })
            return flag;
        }else {
            return true;
        }


    }



    const submit = () => {
        setDisable(true);

        const data: any = {
            ...param,
            convId: props.convId,
            surveyId: surveyId,
            actionCode: props.actionCode
        };
        dispatch(submitFeedbackAction(data));
    }

    const  updateDependItems=(index:number,result:boolean)=>{

        dependItems[index]=result;

        setDependItems(dependItems);

    }

    const whetherShowOrNot=(dependOrder:number):boolean=>{
        console.log("dependOrder:",dependOrder)

        return dependItems[dependOrder];
    }

    return (
        <>
            <div className="chat-feedback-main" data-testid="chatFeedback">
                {
                    items && items.map((item, index) => {
                        return (
                            item.type === "Rating" ?
                                <Rating key={index} title={item.title} size={5} starType={item.starType}
                                        disable={disable} onClick={(num) => {
                                    setCurrentStar({[item.id]: num - 1})
                                    setSelectIndex(num-1)
                                    updateDependItems(item.order,true)
                                    changeParam({[item.field]: {
                                        [num]: {selected: true}}});
                                }}></Rating>
                                : item.type === "RadioGroup"&&whetherShowOrNot(item.dependOrder)?
                                    <MultipleRadioGroup key={index} title={item.title} disable={disable}
                                                        selectedIndex={selectedIndex}
                                                values={item.contentItems} onSelectItems={(result)=>{
                                                    //todo
                                        if(result!=null){
                                            updateDependItems(item.order,true)

                                        }else if(result==null&&inputItem==null){
                                            updateDependItems(item.order,false)
                                        }
                                        setSelectItems(result);
                                        let selectContentParameters={};
                                        let selectContents:any[]=[];
                                        if(result!=null&&result.length>0){
                                            for(let i=0;i<result.length;i++){
                                                //selectContentResult=selectContentResult+result[i].position;
                                                selectContentParameters={...selectContentParameters,
                                                [result[i].position]:{selected:true}}
                                                selectContents.push(result[i].value);
                                            }
                                        }
                                        changeParam({[item.field]:selectContentParameters,[item.fieldValue]:selectContents});

                                    }}
                                    inputContent = {(result,position)=>{
                                        if(result!=null){
                                            setInputItem(result);
                                            updateDependItems(item.order,true);
                                        }else if(selectItems==null&&result==null){
                                            setInputItem(null);
                                            updateDependItems(item.order,false);
                                        }
                                        changeParam({[item.field2]: result});

                                    }}></MultipleRadioGroup>
                                    :item.type==="Decision"&&whetherShowOrNot(item.dependOrder)?
                                        <DecisionComponent disable={disable} ok={item.ok} no={item.no} title={item.title} onClick={(result)=>{
                                            changeParam({[item.field]: {
                                                  [result]:{
                                                      selected:true
                                                  }
                                                },
                                                [item.fieldValue]:result
                                            });

                                            updateDependItems(item.order,true)
                                        }}>
                                        </DecisionComponent>:<></>

                        )
                    })
                }
                <div style={{display: (isHistoryMsg || disable) ? "none" : "block"}}>
                    <button onClick={() => {
                        submit();
                    }} className={checkAllMandatory(dependItems) ? "chat-feedback-submit" : "chat-feedback-submit-disable"}
                            disabled={!checkAllMandatory(dependItems)}>Submit
                    </button>
                </div>
            </div>
        </>
    )
};


interface DecisionProps {
    title?: string;
    disable:boolean;
    ok:string;
    no:string;
    onClick?: (result :number) => void;
}


interface MadaToryItem {
    order:number;
    check:boolean;
}

const DecisionComponent:React.FC<DecisionProps> =(props:DecisionProps) =>{

     const [okVisible,setOkVisible] = useState<boolean>(false);
     const [noVisible,setNoVisible] = useState<boolean>(false);


    return (<>
              <div className="decision-wrap-div">
              <p className="subject-btn-group-title">{props.title}</p>
              <div className="decision-component-div">
              <button
                      disabled={props.disable}
                      className={okVisible?"decision-selected" : "decision-disable"}
                  onClick={()=>{
                      if(!okVisible){
                          setOkVisible(true);
                          setNoVisible(false);
                          props.onClick(1);
                      }


              }}>{props.ok}</button>
                  <a className="place-holder-width"></a>
              <button disabled={props.disable}
                      className={noVisible?"decision-selected" : "decision-disable"}
                     onClick={()=>{
                         if(!noVisible){
                             setOkVisible(false);
                             setNoVisible(true);
                             props.onClick(2);
                         }
              }}>{props.no}</button>
              </div>
              </div>

    </>)
}

interface RadioGroupProps {
    title?: string;
    disable: boolean;
    values: any[];
    onClick?: (event: number, subject: string) => void;
}

const RadioGroup: React.FC<RadioGroupProps> = (props: RadioGroupProps) => {

    const [subject, setSubject] = useState("");

    return (
        <>
            <p className="subject-btn-group-title">{props.title}</p>
            <div hidden={!props.values} className="subject-btn-group">
                {props.values && props.values.map((elem, index) => {
                    return (
                        <button key={index}
                                type="button"
                                disabled={props.disable}
                                className={elem.value === subject ? "subject-btn btn btn-selected" : "subject-btn btn btn-default"}
                                onClick={() => {
                                    setSubject(elem.value);
                                    props.onClick(elem.id, elem.value);
                                }}
                        >
                            {elem.value}
                        </button>
                    )
                })}
            </div>
        </>
    )
}

const MultipleRadioGroup: React.FC<MultipleRadioGroup> = (props: MultipleRadioGroup) => {

    const selectedIndex = props.selectedIndex;
    const contentItem:any = props.values[selectedIndex];
    const showOther:any = contentItem.otherFlag;
    const selectList:any[]=contentItem.selectList;
    const lengthSize=selectList.length;
    const [selectStatus, setSelectStatus] = useState([]);
    const [desc, setDesc] = useState<string>("");
    const [otherFlag,setOtherFlag]= useState<boolean>(false);

    useEffect(()=>{
        console.log("result:",selectedIndex);
        let initialSelectStatus:boolean[]=[];
        for(let i=0;i<lengthSize;i++){
            initialSelectStatus.push(false);
        }
        setSelectStatus(initialSelectStatus)
        setOtherFlag(false)
        setDesc("")

    },[selectedIndex])


    return (
        <>
            <p className="subject-btn-group-title">{props.title}</p>
            <div hidden={!selectList} className="subject-btn-group">
                {selectList && selectList.map((elem, index) => {
                    return (
                        <button key={index}
                                type="button"
                                disabled={props.disable}
                                className={selectStatus[index] ? "subject-btn btn btn-selected" : "subject-btn btn btn-default"}
                                onClick={() => {
                                    selectStatus[index]=!selectStatus[index];
                                    setSelectStatus(selectStatus);
                                    const result:any[]=[];
                                    for(let i=0;i<lengthSize;i++){
                                        if(selectStatus[i]){
                                            result.push(selectList[i])
                                        }
                                    }
                                    props.onSelectItems(result.length==0?null:result);
                                    //props.onClick(elem.id, elem.value);
                                }}
                        >
                            {elem.value}
                        </button>
                    )
                })}
            </div>
            {showOther?<div className="subject-btn-group row-layout">
                  <button type="button"
                   disabled={props.disable}
                   className={otherFlag?"subject-btn btn btn-selected" : "subject-btn btn btn-default"}
                   onClick={()=>{
                   let result=!otherFlag;
                   const selectItems:any[]=[];
                     for(let i=0;i<lengthSize;i++){
                       if(selectStatus[i]){
                           selectItems.push(selectList[i])
                         }
                       }
                   if(!result){
                       setDesc("");
                       props.inputContent(null,0);
                   }else {
                       selectItems.push({value:showOther.title,position: showOther.position})
                   }
                   props.onSelectItems(selectItems.length==0?null:selectItems);
                   setOtherFlag(result);
                   }
                  }>
                      {
                          showOther.title
                      }
                  </button>
                <div className="chat-feedback-multiple-input-div">
                  <textarea
                      disabled={(props.isHistoryMsg || !otherFlag||props.disable)} data-testid="feeback-textarea"
                            maxLength={800}
                            value={desc}
                            style={{width:"100%"}}
                            className="chat-feedback-desc"  onChange={(value) => {
                      setDesc(value.target.value);
                      if(value.target.value===null||value.target.value.trim()===""){
                          props.inputContent(null,0);
                      }else {
                          props.inputContent(value.target.value, showOther.position);
                      }
                  }}
                  >
                  </textarea>
                <span className="chat-feedback-desc-count">{desc.length}/800 characters</span>
                </div>
            </div> :<div></div>}
        </>
    )
}

interface  MultipleRadioGroup{
    selectedIndex?:number;
    starType?:string;
    title?:string;
    isHistoryMsg?:boolean
    showOther?:any;
    values: any;
    disable?:boolean;
    onSelectItems?:(items:any[]) => void;
    inputContent?:(text:string, position:number)=>void;
}




interface RatingProps {
    starType?: string;
    title?: string;
    size?: number;
    disable?: boolean;
    onClick?: (index: number) => void;
}

const Rating: React.FC<RatingProps> = (props: RatingProps) => {

    const [hoverStarNum, setHoverStarNum] = useState(0);
    const [starNum, setStarNum] = useState(0);
    const size = props.size;
    let dom = [];
    for (let i = 1; i <= size; i++) {
        dom.push(i);
    }
    const onClick = (num: number) => {
        props.onClick && props.onClick(num);
    }

    return (
        <div className="rating-wrap">
            <p className="chat-feedback-rate-desc">{props.title ? props.title : 'How would you rate this conversation?'}</p>
            <div className="rating-content">
                <div className="rating-main">
                    {dom.map((number) => {
                        return (
                            <div data-testid="rating-star" key={number} onClick={() => {
                                setStarNum(number);
                                onClick(number);
                            }} onMouseOver={() => {
                                setHoverStarNum(number);
                            }} onMouseLeave={() => {
                                setHoverStarNum(0);
                            }} className={props.disable ? "rating-star-disable" : "rating-star"}>
                                <svg width="31" height="29" viewBox="0 0 31 29" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M13.5979 1.8541C14.1966 0.0114784 16.8034 0.0114794 17.4021 1.8541L19.5413 8.43769C19.809 9.26174 20.5769 9.81966 21.4434 9.81966H28.3658C30.3032 9.81966 31.1088 12.2989 29.5413 13.4377L23.941 17.5066C23.24 18.0159 22.9467 18.9186 23.2145 19.7426L25.3536 26.3262C25.9523 28.1689 23.8433 29.7011 22.2759 28.5623L16.6756 24.4934C15.9746 23.9841 15.0254 23.9841 14.3244 24.4934L8.72409 28.5623C7.15666 29.7011 5.0477 28.1689 5.64641 26.3262L7.78555 19.7426C8.0533 18.9186 7.75998 18.0159 7.059 17.5066L1.45867 13.4377C-0.108762 12.2989 0.69679 9.81966 2.63424 9.81966H9.55664C10.4231 9.81966 11.191 9.26174 11.4587 8.43769L13.5979 1.8541Z"
                                        fill={(hoverStarNum || starNum) >= number ? "#FF9901" : "#E2E7EC"}/>
                                </svg>
                            </div>)
                    })}
                </div>
                <div className="chat-feedback-default-msg"
                     style={{display: props.starType === 'starStyle1' ? "flex" : "none"}}>
                    <div>Very Dissatisfied</div>
                    <div>Very Satisfied</div>
                </div>
                <div className="chat-feedback-msg" hidden={props.starType && props.starType !== 'starStyle2'}>
                    <span hidden={!((hoverStarNum || starNum) === 1)}>Poor</span>
                    <span hidden={!((hoverStarNum || starNum) === 2)}>Fair</span>
                    <span hidden={!((hoverStarNum || starNum) === 3)}>Good</span>
                    <span hidden={!((hoverStarNum || starNum) === 4)}>Very Good</span>
                    <span hidden={!((hoverStarNum || starNum) === 5)}>Excellent</span>
                    <span className="chat-feedback-msg-no-star" hidden={!((hoverStarNum || starNum) === 0)}></span>
                </div>
            </div>
        </div>
    )
}
export default NewChatFeedback;